import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { BolsaBasura, CleanKoaxka, ContainerCleaning, MapOxxoTopicTwo, Microware, PanecitosTwo, RelojCircle, TooltipsKoxka, Warmer } from "../objects/Topics";
import { CubeSelect } from "../objects/CubeSelect";
import { SphereSelect } from "../objects/SphereSelect";
import { EstanteRefri } from "../objects/Topics/TopicTwo/EstanteRefri";


export class SceneTopicTwo extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicTwo(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.warner = new Warmer(this.loadingManager)

		this.clockCircle = new RelojCircle(this.loadingManager)
		this.estanteRefri = new EstanteRefri(this.loadingManager)

		this.cubePaso1 = new CubeSelect("paso1", 0xffffff)
		this.cubePaso2 = new CubeSelect("paso2", 0xffffff)
		this.spheraPaso3 = new SphereSelect("paso3", 0xffffff)

		this.panecitos1 = new PanecitosTwo(this.loadingManager)
		this.panecitos2 = new PanecitosTwo(this.loadingManager)

		this.containerClean = new ContainerCleaning(this.loadingManager)
		this.microware = new Microware(this.loadingManager)

		this.tooltipsKoxka = new TooltipsKoxka(this.loadingManager)

		this.garbageBag = new BolsaBasura(this.loadingManager)

		this.cleanKoaxka = new CleanKoaxka(this.loadingManager)
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	SceneInitialState() {

	}

	characterPositionOne() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
	}

	restoreActOne() {
		this.map.Pan_dulce.visible = true
		this.map.Microondas.visible = true
		this.warner.visible = false
		this.clockCircle.visible = false
		this.cubePaso1.visible = false
		this.panecitos1.visible = false
		this.panecitos2.visible = false
		this.containerClean.visible = false
		this.microware.visible = false

		this.estanteRefri.visible = false
		this.map.Estantes_refris.visible = true
	}

	initSceneOne() {
		this.warner.visible = true
		this.clockCircle.visible = true
		this.microware.visible = true
		this.containerClean.visible = true


		this.cubePaso1.clearAnimation()
		this.clockCircle.onClearAnimation()
		this.map.Puerta.material.opacity = 1
		this.map.Puerta_1.material.opacity = 1

		this.microware.onAnimateEmisseve()

		this.containerClean.Trapo.visible = false
		this.microware.Puerta_Micro.rotation.set(0, 0, 0)

		this.panecitos1.visible = true
		this.panecitos1.Cuernito.rotation.set(0, 0, 0)

		this.microware.Cuernito.material.emissiveIntensity = 1

		this.map.Estantes_refris.visible = false

		this.estanteRefri.visible = true
		this.add(this.estanteRefri)

	}

	sceneActivityOneState() {
		this.characterPositionOne()

		this.mouseEvents.disposeInteractions()

		this.map.Pan_dulce.visible = false
		this.map.Microondas.visible = false

		this.warner.position.set(-14.5842, -1.5118, -7.0663)
		this.warner.rotation.y = 1.5512
		this.add(this.warner)

		this.clockCircle.position.set(-14.9686, 0.2671, -5.7052)
		this.clockCircle.rotation.y = 1.5512
		this.clockCircle.scale.set(0.3382, 0.3382, 0.3382)
		this.add(this.clockCircle)

		this.cubePaso1.position.set(-14.2711, -1.2987, -7.0535)
		this.cubePaso1.scale.set(0.24, 0.18, 0.98)

		this.cubePaso1.visible = false
		this.add(this.cubePaso1)

		this.panecitos1.position.set(-14.0863, -0.8529, -6.9183)
		this.panecitos1.rotation.set(1.5512, 0, -1.7571)
		this.panecitos1.Dona.visible = false
		this.panecitos1.Panque.visible = false
		this.panecitos1.Cuernito.visible = false
		this.add(this.panecitos1)

		this.panecitos2.visible = false
		this.add(this.panecitos2)

		this.containerClean.position.set(-14.0863, -0.8529, -6.9183)
		this.containerClean.onInVisibleAll()
		this.add(this.containerClean)

		this.microware.position.set(-8.6436, -1.514, -10.2952)
		this.microware.Cuernito.position.y = 0.0629
		this.add(this.microware)

		this.initSceneOne()


		ObserverEmitter.on(EVENTS.tema3.topic2.actOne.moveAroundStation, (step = "") => {
			switch (step) {
				case "wall_clock":
					this.characterSelected.visible = false
					this.camera.moveCameraToPoint(new Vector3(-11.9225, -0.15, -7.0532), 1, new Vector3(-14.745, -0.97, -7.05), () => {
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
					})
					break;
				case "room_cold":
					this.cubePaso1.clearAnimation()
					this.cubePaso1.visible = false
					this.clockCircle.onClearAnimation()
					this.panecitos1.Cuernito.visible = false

					this.camera.moveCameraToPoint(new Vector3(-7.3017, 0.0776, 8.144), 2, new Vector3(-4.484, -0.7, 8.451), () => {
						this.camera.moveCameraToPoint(new Vector3(4.8502, 0.6691, 10.368), 2, new Vector3(7.633, -0.266, 10.504), () => {

							this.map.onAnimationOpacity(this.map.Puerta, () => {
								this.camera.moveCameraToPoint(new Vector3(14.3733, 0.6053, 8.7292), 2, new Vector3(12.133, -0.504, 7.184), () => {

									this.map.onAnimationOpacity(this.map.Puerta_1, () => {
										this.camera.moveCameraToPoint(new Vector3(10.9084, 0.3438, 6.4113), 2, new Vector3(11.136, -0.305, 3.554), () => {
											this.panecitos1.position.set(3, -0.7203, -7.1774)
											this.panecitos1.rotation.set(0, 3.0951, 0)
											this.panecitos1.Panque.position.x = -0.2949
											this.panecitos1.Dona.position.x = -0.1543
											this.panecitos1.Cuernito.position.set(0, 0, 0)

											this.panecitos2.position.set(3, -0.1474, -7.1774)
											this.panecitos2.rotation.set(0, 3.0951, 0)
											this.panecitos2.Panque.position.x = -0.2949
											this.panecitos2.Dona.position.x = -0.1543
											this.panecitos2.visible = true

											this.panecitos1.Dona.visible = true
											this.panecitos1.Panque.visible = true
											this.panecitos1.Cuernito.visible = true

											this.camera.moveCameraToPoint(new Vector3(11.1843, -0.1632, -8.601), 2, new Vector3(8.377, -0.623, -7.862), () => {
												this.camera.moveCameraToPoint(new Vector3(3.5859, 0.7535, -9.9338), 2, new Vector3(2.407, -0.326, -7.468), () => {
													ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "room_cold")
												})
											})
										})
									})

								})
							})

						})
					})
					break;

				case "go_back_microwave":

					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;

					this.camera.moveCameraToPoint(new Vector3(10.2767, 0.6581, -10.1342), 2, new Vector3(10.24, -0.235, -7.335), () => {
						this.camera.moveCameraToPoint(new Vector3(10.5458, 0.8878, 6.7477), 2, new Vector3(13.359, 0.069, 6.967), () => {
							this.camera.moveCameraToPoint(new Vector3(14.4395, 0.351, 9.7197), 2, new Vector3(11.553, -0.194, 9.81), () => {
								this.camera.moveCameraToPoint(new Vector3(-6.9613, 1.0477, 7.9977), 2, new Vector3(-7.628, 0.253, 5.248), () => {
									this.camera.moveCameraToPoint(new Vector3(-7.6379, -0.2063, -8.469), 1, new Vector3(-8.851, -1.491, -10.818), () => {
										this.microware.onAnimationMoveRotation(this.microware.Puerta_Micro, { x: 0, y: -0.9852, z: 0 }, 2, () => {
											this.microware.onAnimateEmisseve(this.microware.Cuernito)

											ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "view_microware")
										})
									})
								})
							})
						})
					})

					break;

				case "wall_clock_final":
					this.camera.moveCameraToPoint(new Vector3(-11.9225, -0.15, -7.0532), 1, new Vector3(-14.745, -0.97, -7.05), () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "final_message")
					})
					break;

				default:
					break;
			}
		})

		ObserverEmitter.on(EVENTS.tema3.topic2.actOne.stepActivateInformation, (step = "") => {
			this.cubePaso1.clearAnimation()
			this.clockCircle.onClearAnimation()
			this.containerClean.Trapo.visible = false
			switch (step) {
				case "turn_on_machine":
					this.clockCircle.onAnimateEmissive()
					this.cubePaso1.onAnimationOpacity()
					this.cubePaso1.visible = true
					this.panecitos1.Cuernito.visible = true
					this.panecitos1.Cuernito.position.set(0, 0, 0)
					this.panecitos1.Cuernito.rotation.set(0, 0, 0)
					break;
				case "select_product":
					this.panecitos1.onAnimationMovePosition(this.panecitos1.Cuernito, { x: -0.1027, y: 0.6224, z: 1.083 })
					this.panecitos1.onAnimationMoveRotation(this.panecitos1.Cuernito, { x: 1.0945, y: 0.141, z: 0.2706 }, 2,
						() => {
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.finishMoveAnimation, "select_product")
						}
					)
					break;

				case "visible_trapo":
					this.containerClean.Trapo.visible = true
					break;

				default:
					this.restoreActOne()
					break;
			}
		})

	}

	restoreActTwo() {
		this.map.Pan_dulce.visible = true
		this.warner.visible = false
		this.clockCircle.visible = false
		this.cubePaso1.visible = false
		this.cubePaso1.clearAnimation()
		this.cubePaso2.visible = false
		this.cubePaso2.clearAnimation()
		this.spheraPaso3.visible = false
		this.spheraPaso3.clearAnimation()
	}

	initSceneTwo() {
		this.cubePaso1.clearAnimation()
		this.cubePaso2.clearAnimation()
		this.spheraPaso3.clearAnimation()
		this.clockCircle.onClearAnimation()
	}

	sceneActivityTwoState() {
		this.characterPositionOne()


		this.map.Pan_dulce.visible = false

		this.warner.position.set(-14.5842, -1.5118, -7.0663)
		this.warner.rotation.y = 1.5512
		this.warner.visible = true
		this.add(this.warner)

		this.clockCircle.position.set(-14.9686, 0.2671, -5.7052)
		this.clockCircle.rotation.y = 1.5512
		this.clockCircle.scale.set(0.3382, 0.3382, 0.3382)
		this.clockCircle.visible = true
		this.add(this.clockCircle)

		this.cubePaso1.position.set(-14.1396, -0.6276, -7.0459)
		this.cubePaso1.scale.set(0.06, 1.39, 1.16)
		this.cubePaso1.visible = false
		this.add(this.cubePaso1)

		this.cubePaso2.position.set(-14.2711, -0.5337, -7.0542)
		this.cubePaso2.scale.set(0.08, 1.07, 1.02)
		this.cubePaso2.visible = false
		this.add(this.cubePaso2)

		this.spheraPaso3.position.set(-14.2711, -1.2062, -7.0542)
		this.spheraPaso3.scale.set(0.0061, 0.0043, 0.0056)
		this.spheraPaso3.visible = false
		this.add(this.spheraPaso3)

		this.initSceneTwo()

		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema3.topic2.actTwo.moveWanner, (step = "") => {
			switch (step) {
				case "move_wanner":
					this.characterSelected.visible = false
					this.camera.moveCameraToPoint(new Vector3(-11.3932, 0.6332, -6.6892), 1, new Vector3(-14.069, -0.578, -6.799), () => {
					})
					break;

				default:
					break;
			}
		})

		ObserverEmitter.on(EVENTS.tema3.topic2.actTwo.activyObj, (step = "") => {
			this.mouseEvents.disposeInteractions()
			this.mouseEvents.objectsToValue = [];

			switch (step) {
				case "all_warner":
					this.cubePaso1.onAnimationOpacity()
					this.cubePaso1.visible = true
					this.mouseEvents.objectsToValue = [this.cubePaso1];
					break;
				case "clock":
					this.clockCircle.onAnimateEmissive()
					this.mouseEvents.objectsToValue = [this.clockCircle];
					this.cubePaso1.clearAnimation()
					this.cubePaso1.visible = false
					break;
				case "clean":
					this.cubePaso2.onAnimationOpacity()
					this.cubePaso2.visible = true
					this.mouseEvents.objectsToValue = [this.cubePaso2];
					this.clockCircle.onClearAnimation()
					break;
				case "temperatura":
					this.spheraPaso3.onAnimationOpacity()
					this.spheraPaso3.visible = true
					this.mouseEvents.objectsToValue = [this.spheraPaso3];
					this.cubePaso2.clearAnimation()
					this.cubePaso2.visible = false
					break;
				default:
					this.restoreActTwo()
					break;
			}

			this.mouseListeners()

		})

	}

	restoreActThree() {
		this.tooltipsKoxka.visible = false
		this.cubePaso1.visible = false
		this.tooltipsKoxka.clearAnimation()
	}
	sceneActivityThreeState() {
		this.characterPositionOne()

		this.characterSelected.rotation.y = 0.5587

		this.mouseEvents.disposeInteractions()

		this.tooltipsKoxka.position.set(-6.6615, -0.4539, -10.0555)
		this.tooltipsKoxka.scale.set(1, 1, 1)
		this.tooltipsKoxka.pizzas.position.y = 0.9115
		this.tooltipsKoxka.postres.position.y = -0.8529
		this.tooltipsKoxka.visible = false
		this.add(this.tooltipsKoxka)

		ObserverEmitter.on(EVENTS.tema3.topic2.actThree.actKoxka, (step = "") => {
			switch (step) {
				case "move_koxka":
					this.camera.moveCameraToPoint(new Vector3(-5.5972, 0.2217, -7.2201), 1, new Vector3(-5.608, -0.816, -9.97), () => {
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
					})
					break;
				case "tooltip_koxka":
					this.tooltipsKoxka.visible = true
					this.tooltipsKoxka.onAnimateOpacity()
					break;

				default:
					this.restoreActThree()
					break;
			}
		})

	}

	restoreActFour() {
		this.garbageBag.visible = false
		this.map.clearAnimation()
		this.map.Puerta.material.opacity = 1
	}

	sceneActivityFourState() {
		this.characterPositionOne()

		this.characterSelected.rotation.y = 0.5587

		this.garbageBag.position.set(-4.3818, -2.9547, -5.7052)
		this.garbageBag.visible = false
		this.add(this.garbageBag)

		this.map.clearAnimation()
		this.map.Puerta.material.opacity = 1

		ObserverEmitter.on(EVENTS.tema3.topic2.actFour.actBolsa, (step = "") => {
			switch (step) {
				case "view_garbage_bag":
					this.garbageBag.visible = true
					break;
				case "select_product_time_out":
					this.garbageBag.visible = false
					this.characterSelected.visible = false
					this.camera.moveCameraToPoint(new Vector3(-5.5972, 0.2217, -7.2201), 1, new Vector3(-5.608, -0.816, -9.97), () => {
						this.map.onAnimateEmissiveMultiIntensity([this.map.Bolsa_1, this.map.Yoghurt_20, this.map.Yoghurt_9])
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.finishMoveActBolsa, "view_koaxka")
					})
					break;
				case "move_room_cold":
					this.map.clearAnimation()
					this.camera.moveCameraToPoint(new Vector3(-7.3017, 0.0776, 8.144), 2, new Vector3(-4.484, -0.7, 8.451), () => {
						this.camera.moveCameraToPoint(new Vector3(4.8502, 0.6691, 10.368), 2, new Vector3(7.633, -0.266, 10.504), () => {

							this.map.onAnimationOpacity(this.map.Puerta, () => {
								this.camera.moveCameraToPoint(new Vector3(13.5991, 0.503, 9.4042), 2, new Vector3(13.522, -0.568, 6.668), () => {
									this.camera.moveCameraToPoint(new Vector3(15.0455, 0.4331, 0.577), 2, new Vector3(12.926, -0.813, 2.187), () => {
										this.garbageBag.position.set(12.8216, -1.7352, 2.676)
										this.garbageBag.visible = true
										ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.finishMoveActBolsa, "Bolsa")
									})
								})
							})

						})
					})
					break;
				case "go_back":
					this.camera.moveCameraToPoint(new Vector3(14.1301, 0.109, 9.7587), 2, new Vector3(11.406, -0.979, 9.583), () => {
						this.camera.moveCameraToPoint(new Vector3(-7.7007, 0.4015, 9.1375), 2, new Vector3(-7.548, -0.664, 6.403), () => {
							this.camera.moveCameraToPoint(new Vector3(-4.6962, -1.5072, -1.9068), 1, new Vector3(-5.92, -1.779, -4.565), () => {
								this.characterSelected.visible = true
								ObserverEmitter.emit(EVENTS.tema3.topic2.actFour.finishMoveActBolsa, "go_back")
							})
						})
					})
					break;
				default:
					this.restoreActFour()
					break;
			}
		})

		this.mouseEvents.disposeInteractions()
	}

	restoreActFive() {
		this.cleanKoaxka.visible = false
		this.map.Refirs_Delixia.visible = true
	}

	sceneActivityFiveState() {
		this.characterPositionOne()

		this.map.Refirs_Delixia.visible = false

		this.cleanKoaxka.Estantes.material.aoMapIntensity = 0

		this.cleanKoaxka.position.set(-6.1107, -3.157, -10.1968)
		this.cleanKoaxka.visible = true
		this.cleanKoaxka.Trapo.visible = false
		this.cleanKoaxka.Rollo.visible = false
		this.add(this.cleanKoaxka)

		ObserverEmitter.on(EVENTS.tema3.topic2.actFive.actCleanKoaxka, (step = "") => {
			switch (step) {
				case "move_koxka":
					this.camera.moveCameraToPoint(new Vector3(-5.5972, 0.2217, -7.2201), 1, new Vector3(-5.608, -0.816, -9.97), () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "move_koxka")
					})
					break;
				case "remove_product_1":
					this.cleanKoaxka.onOpacityMultiple(this.cleanKoaxka.shelvesGroup.shelvesOne, 0, 1, () => {
						this.cleanKoaxka.onVisibleMultiple(this.cleanKoaxka.shelvesGroup.shelvesOne, false)
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "remove_product_1")
					})
					break;
				case "clean_product_1":
					this.cleanKoaxka.Trapo.visible = true
					this.cleanKoaxka.Trapo.position.set(0.5804, 1.7937, 0)
					this.cleanKoaxka.onAnimationMovePosition(this.cleanKoaxka.Trapo, { x: -0.4674, y: 1.7937, z: 0 }, 1, () => {
						this.cleanKoaxka.Trapo.visible = false
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "clean_product_1")
					})
					break;
				case "remove_product_2":
					this.cleanKoaxka.onOpacityMultiple(this.cleanKoaxka.shelvesGroup.shelvesTwo, 0, 1, () => {
						this.cleanKoaxka.onVisibleMultiple(this.cleanKoaxka.shelvesGroup.shelvesTwo, false)
						this.cleanKoaxka.Trapo.visible = true
						this.cleanKoaxka.Trapo.position.set(0.5804, 1.3526, 0)
						this.cleanKoaxka.onAnimationMovePosition(this.cleanKoaxka.Trapo, { x: -0.4674, y: 1.3526, z: 0 }, 1, () => {
							this.cleanKoaxka.Trapo.visible = false
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "remove_product_2")
						})
					})
					break;
				case "place_product_1":
					this.cleanKoaxka.onVisibleMultiple(this.cleanKoaxka.allProductChangueMaterial, true)
					this.cleanKoaxka.onOpacityMultiple(this.cleanKoaxka.allProductChangueMaterial, 1, 1, () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "place_product_1")
					})
					break;
				case "remove_product_all":
					this.cleanKoaxka.onOpacityMultiple(this.cleanKoaxka.allProductChangueMaterial, 0, 1, () => {
						this.cleanKoaxka.onVisibleMultiple(this.cleanKoaxka.allProductChangueMaterial, false)
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "remove_product_all")
					})
					break;
				case "detect_holes"://! sin uso
					ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "detect_holes")
					break;
				case "move_product_up":
					this.cleanKoaxka.onAnimationMovePosition(this.cleanKoaxka.Estantes, { x: 0, y: 0.137, z: 0 }, 1, () => {
						this.cleanKoaxka.onOpacityObject(this.cleanKoaxka.Estantes, 0, 1, () => {
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "move_product_up")
						})
					})
					break;
				case "remove_slits":
					this.cleanKoaxka.onOpacityObject(this.cleanKoaxka.Base_repisa, 0, 1, () => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "remove_slits")
					})
					break;
				case "clean_cracks":
					this.cleanKoaxka.Trapo.visible = true
					this.cleanKoaxka.Trapo.position.set(0.5804, 1.3526, 0)
					this.cleanKoaxka.onAnimationMovePosition(this.cleanKoaxka.Trapo, { x: -0.4674, y: 1.3526, z: 0 }, 1, () => {
						this.cleanKoaxka.onOpacityObject(this.cleanKoaxka.Base_repisa, 1, 1, () => {
							this.cleanKoaxka.Trapo.visible = false
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "clean_cracks")
						})
					})
					break;
				case "clean_all":
					this.cleanKoaxka.Rollo.position.set(0.4704, 1.3526, 0)
					this.cleanKoaxka.Rollo.visible = true
					this.cleanKoaxka.onAnimationMovePosition(this.cleanKoaxka.Rollo, { x: -0.333, y: 1.3526, z: 0 }, 1, () => {
						this.cleanKoaxka.Rollo.visible = false
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "clean_all")
					})
					break;
				case "add_slits":
					this.cleanKoaxka.onOpacityObject(this.cleanKoaxka.Estantes, 1, 1, () => {
						this.cleanKoaxka.onAnimationMovePosition(this.cleanKoaxka.Estantes, { x: 0, y: 0, z: 0 }, 1, () => {
							this.cleanKoaxka.onVisibleMultiple(this.cleanKoaxka.allProductChangueMaterial, true)
							this.cleanKoaxka.onOpacityMultiple(this.cleanKoaxka.allProductChangueMaterial, 1, 1, () => {
								ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "add_slits")
							})
						})
					})
					break;
				case "go_back_init":
					this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
						this.characterSelected.visible = true
						ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, "go_back_init")
					})
					break;
				default:
					this.restoreActFive()
					break;
			}
		})
	}

	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				//* posicion panes
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false
					this.activeAudio()

					this.sceneActivityTwoState()
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-4.6962, -1.5072, -1.9068), 1, new Vector3(-5.92, -1.779, -4.565), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityThreeState()
				});
				break;
			case 4:
				this.camera.moveCameraToPoint(new Vector3(-4.6962, -1.5072, -1.9068), 1, new Vector3(-5.92, -1.779, -4.565), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityFourState()
				});
				break;
			case 5:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityFiveState()
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.tema3.topic2.actTwo.clickRayCaster, name)
			}
		});
	}

	renderAnimations(delta) {
	}
}
